module.exports = "/pen.cur?47a1fe68f239503434627d7dafb2143d";